<template>
    <div class="error-page">
<!--        <div class="error-code">4<span>0</span>1</div>-->
        <div class="error-desc">系统当前无此用户或您已长时间未登录，请重新登录！返回码401</div>
        <div class="error-handle">
            <router-link to="/login">
                <el-button type="primary" size="large" @click="goBacks">重 新 登 录</el-button>
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            goBacks(){
                this.$router.push("/login");
            },
            goBack(){
                this.$router.go(-1);
            }
        }
    }
</script>


<style scoped>
    .error-page{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
        height: 100%;
        background: #f3f3f3;
        box-sizing: border-box;
    }
    .error-code{
        line-height: 1;
        font-size: 250px;
        font-weight: bolder;
        color: #f02d2d;
    }
    .error-code span{
        color: #00a854;
    }
    .error-desc{
        font-size: 30px;
        color: #777;
    }
    .error-handle{
        margin-top: 30px;
        padding-bottom: 200px;
    }
    .error-btn{
        margin-left: 100px;
    }
</style>
